'use client';

import {upperFirst} from 'lodash';
import {useTranslations} from 'next-intl';
import {useMemo, useState} from 'react';
import {Radio} from '../../../../../../components/design-system';
import {useFindCategoriesQuery} from '../../query/useFindFacetsQuery';
import useFilters from '../hooks/useFilters';
import FilterModal from './FilterModal';

export default function FilterCategory() {
  const t = useTranslations('shop');

  const {data: facets} = useFindCategoriesQuery();
  const {filters, set} = useFilters();

  const [selected, setSelected] = useState({
    category: filters.category || [],
    subcategory: filters.subcategory || [],
  });

  // useEffect(() => {
  //   setSelected({
  //     category: filters.category || [],
  //     subcategory: filters.subcategory || [],
  //   });
  // }, [filters.category, filters.subcategory]);

  const appliedValue = useMemo(() => {
    const category =
      !!filters.category && filters.category.length > 0
        ? facets?.categories.find((f) => f.slug === filters.category![0])
        : undefined;
    const subcategory =
      !!filters.subcategory && filters.subcategory.length > 0
        ? facets?.categories
            .reduce((acc, curr) => [...acc, ...curr.children], [])
            .find((f) => f.slug === filters.subcategory![0])
        : undefined;

    if (!category && !subcategory) {
      return undefined;
    }

    return [
      upperFirst(category?.name || filters.category![0]),
      !!subcategory
        ? `, ${upperFirst(subcategory?.name || filters.subcategory![0])}`
        : '',
    ].join('');
  }, [filters.category, filters.subcategory]);

  function handleChangeCategory(value: string) {
    setSelected({
      category: value === selected.category[0] ? [] : [value],
      subcategory: [],
    });
  }

  function handleChangeSubcategory(category: string, subcategory: string) {
    setSelected({
      category: [category],
      subcategory: subcategory === selected.subcategory[0] ? [] : [subcategory],
    });
  }

  function handleApply() {
    set({category: selected.category, subcategory: selected.subcategory});
  }

  return (
    <FilterModal
      label={t('filter.category.title')}
      appliedValue={appliedValue}
      onApply={() => handleApply()}
    >
      <form className="px-4 space-y-2">
        {(facets?.categories || []).map((category) => (
          <div key={category.id}>
            <Radio
              name="category"
              onChange={(value) => handleChangeCategory(value)}
              selectedValue={selected.category[0]}
              value={category.slug}
              // label={`${upperFirst(category.name)} (${category.count})`}
              label={upperFirst(category.name)}
              reverse
            />
            {category.children.map((subcategory) => (
              <div key={subcategory.id} className="pl-4 mt-2">
                <Radio
                  name="subcategory"
                  onChange={(value) =>
                    handleChangeSubcategory(category.slug, value)
                  }
                  selectedValue={selected.subcategory[0]}
                  value={subcategory.slug}
                  // label={`${upperFirst(subcategory.name)} (${subcategory.count})`}
                  label={upperFirst(subcategory.name)}
                  reverse
                />
              </div>
            ))}
          </div>
        ))}
      </form>
    </FilterModal>
  );
}
